import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: '',
  table: 'ble_devices_type',
  title: 'Типы BLE-меток',
  apiType: apiTypes.ALT_NAV_API,
  elemsOnPage: 100,
  connections: { },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'name_type',
      title: 'Тип',
      type: 'text',
      required: true,
    },
  ],
  newTemplate: {
    name_type: '',
  },
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'id',
        field: 'id'
      },
      {
        title: 'name_type',
        field: 'name_type'
      },
    ],
    example: `1;Тип 1`
  }
};

export default config;